var vms = vms || {};
vms.item = vms.item || {};

vms.item.refresh_item = function (pPage) {
    var missCerts = [82, 124, 370];
    if (missCerts.indexOf(pPage) != -1) {
        apex.server.process("checkRequiredCertificates", {
            x01: $v('P' + pPage + '_WP_ID'),
            x02: $v('P' + pPage + '_PROFILE_ID')
        }, {
                dataType: "text",
                success: function (pData) {
                    if (pData == '') {
                        $("#missCerts").hide();
                    }
                    else {
                        $('#missCerts').removeAttr("style");
                        $('#missCerts').html(pData);
                    }
                }
            });
    }
}

vms.item.sendClob = function (pCall, pArray, pRequest) {
	if (pArray[pCall-1] || pCall === 1) {
		var p = apex.server.process('setClob', {
					x01: pCall,
					x02: pArray[pCall-1]
				}, {
					dataType: 'html'
				});
		p.done(function(data) {
			vms.item.sendClob(pCall + 1, pArray, pRequest);
		})
	} else {
		apex.submit(pRequest);
	}
}

vms.item.getClob = function (pItemId, pItemName) {
    CKEDITOR.on("instanceReady", function(event) {
		// Run the Ajax Callback process
		var p = apex.server.process('getClob', {
					pageItems:[pItemId]
				}, {
					dataType: 'html'
				});
		// When the process is done, set the value to the page item
		p.done(function(data) {
		apex.item(pItemName).setValue(data);
		});
	});
}


/** created on: 24.01.2019 by:Davor
*  updated on: ...
*  include select2 files if needed (pg0)
*/
vms.item.gen = function (pItem, pData) {
    var vRet = "", vTemp, vHidden = "", vData = false, vValue, vWidth;
    let temp;
    if (pData) vData = true;
    vTemp = "";
    // set item value
    if (vData) vValue = $nvl(pData.r, pItem.def);
    else vValue = pItem.def;
    // set item width if specified
    if (pItem.width) vWidth = 'width:' + pItem.width + 'px;';
    if (pItem.widthPct) vWidth = 'width:' + pItem.widthPct + '%;';
    else vWidth = '';
    // generate item based on his type
    switch (pItem.type) {
        // Hidden item
        case "H": vHidden += '<input type="hidden" id="' + pItem.id + '" value="' + vValue + '" />';
            break;
        // Number item
        case "N": vTemp = '<input type="text" id="' + pItem.id + '" value="' + vValue + '" class="number_field apex-item-text" style="text-align:right;' + vWidth + '" />';
            break;
        // Text item
        case "P": vTemp = '<input type="password" id="' + pItem.id + '" value="" class="password apex-item-text"' + (vWidth ? ' style="' + vWidth + '"' : '') + ' autocomplete="off" />';
            break;
        // Text item
        case "T": vTemp = '<input type="text" id="' + pItem.id + '" value="' + vValue + '" class="text_field apex-item-text"' + (vWidth ? ' style="' + vWidth + '"' : '') + ' />';
            break;
        // Text area item
        case "TA": vTemp = '<textarea rows="1" id="' + pItem.id + '" class="textarea apex-item-textarea" style="' + vWidth
            + '">' + vValue + '</textarea>';
            break;
        // Date Item
        case "D": vTemp = '<input type="text" id="' + pItem.id + '" value="' + vValue + '" class="ajaxForm__lxpMrDate" />';
            // todo add datepicker js
            break;
        // Display value, saves item state
        case "DS": vTemp += vValue + '<input type="hidden" id="' + pItem.id + '" value="' + vValue + '" />';
            break;
        // Display value only
        case "DO": vTemp += vValue + '<input type="hidden" id="' + pItem.id + '" value="' + vValue + '" />';
            break;
        // Select item
        case "S": var vSelected = false;
            for (var o = 0; o < pItem.options.length; o++) {
                if (vValue == pItem.options[o].r) {
                    vSelected = true;
                    vTemp += '<option value="' + pItem.options[o].r + '" selected >'
                        + pItem.options[o].d + '</option>';
                } else vTemp += '<option value="' + pItem.options[o].r + '">'
                    + pItem.options[o].d + '</option>';
            }
            if (vData && typeof vValue != 'undefined' && !vSelected) vTemp += '<option value="' + vValue + '" selected>' + pData.d + '</option>';
            vTemp = '<select class="ajaxForm__mrSelect" id="' + pItem.id + '"' + (vWidth ? ' style="' + vWidth + '"' : '') + '>' + vTemp
                + '</select>';
            break;
		// Radio button
		/*case "RADIO":
        vTemp += '<div class="col col-12 apex-col-auto ajaxForm__related"><div class="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs t-Form-fieldContainer--radioButtonGroup apex-item-wrapper apex-item-wrapper--radiogroup " id="' + pItem.id + '"><div class="t-Form-labelContainer">'
			+ '<label for="' + pItem.id + '" id="' + pItem.id + '_LABEL" class="t-Form-label">' + pItem.label + '</label>'
			+ '</div><div class="t-Form-inputContainer"><div class="t-Form-itemWrapper"><div tabindex="-1" id="' + pItem.id + '" aria-labelledby="' + pItem.id + '_LABEL" class="radio_group apex-item-group apex-item-group--rc apex-item-radio" role="group">'
			+ '<div class="apex-item-grid radio_group">'
			+ '<div class="apex-item-grid-row">'
			+'<div class="apex-item-option"><input type="radio" id="' + pItem.id + '_0" name="' + pItem.id + '" value="Y"><label class="u-radio" for="' + pItem.id + '_0">Yes</label></div>'
			+ '<div class="apex-item-option"><input type="radio" id="' + pItem.id + '_1" name="' + pItem.id + '" value="N" checked="checked"><label class="u-radio" for="' + pItem.id + '_1">No</label></div>'
			+ '</div></div></div>'
			+ '</div><span id="' + pItem.id + '_error_placeholder" class="a-Form-error"></span></div></div></div>';		
			break;*/
		// Text item
        case "SArr": vTemp = '<input class="ajaxForm__mrSelectArr" type="text" id="' + pItem.id + '" value="' + vValue + '"' + (vWidth ? ' style="' + vWidth + '"' : '') + ' lov="' + pItem.lov + '" />';
            break;
        // Checkbox item
        case "C": var vValueArr = vValue.split(":"), vChecked;
            for (var i = 0; i < pItem.options.length; i++) {
                vChecked = '';
                for (var j = 0; j < vValueArr.length; j++) {
                    if (vValueArr[j] == pItem.options[i].r) vChecked = ' checked="checked"';
                }
                vTemp += '<input type="checkbox" id="' + pItem.id + '_' + i + '" value="' + pItem.options[i].r
                    + '"' + vChecked + '" /><label>' + pItem.options[i].d + '</label>';
            }
            vTemp = '<span class="ajaxForm__chk" id="' + pItem.id + '">' + vTemp + '</span>';
            break;
        // Critical check (Equipment)
        case "critical": temp = pItem.lov[pItem.lov.map(e => e.val).indexOf(vValue)];
            vTemp = '<div class="row"><div class="col col-12 apex-col-auto"><div class="ajaxForm__critical '+ temp.class +'" id="afi-' + pItem.id + '">'
				  +  '<input type="hidden" id="' + pItem.id + '" value="' + vValue + '" />'
				  +  '<span>' + temp.text + '</span>'
				  /*+  '<a href="' + pData.link + '" role="button" title="Check Status"><Check Status</a>'*/
				  + '<nav class="t-Button t-Button--icon t-Button--iconLeft t-Button--mobileHideLabel" onclick="' + pData.link + '"><span class="t-Icon t-Icon--left far fawe-check-square"></span><span class="t-Button-label">Update</span></nav>'
				  + '</div></div>';
            break;
        // Class Related Component
        case "related": 
            vValue = $nvl((vValue == "" ? 'N' : vValue),'N');
            temp = pItem.lov[pItem.lov.map(e => e.val).indexOf(vValue)];
            vTemp = (temp.text ? '<label class="t-Form-label">' + temp.text + '</label> ' : '') +
                  '<input type="hidden" id="' + pItem.id + '" value="' + vValue + '" data-lov="'+ encodeURIComponent( JSON.stringify(pItem.lov) ) +'" />'+
                  '<nav class="t-Button t-Button--icon t-Button--iconLeft t-Button--mobileHideLabel" onclick="vms.item.relatedToggle(this);"><span class="t-Icon t-Icon--left far fawe-check-square"></span><span class="t-Button-label">Update</span></nav>'
                  ;
            break;
        // Critical check (Equipment)
        case "buttonList": //console.log(pItem);
            for (var i = 0; i < pItem.buttons.length; i++) {
                vTemp += '<li onclick="'
                    + ((vValue[i].indexOf("f?p=") == 0) ? 'redirect(\'' + vValue[i] + '\')' : vValue[i])
                    + '">' + pItem.buttons[i].text + '</li>';
            }
            vTemp = '<ul class="ajaxForm__buttonList" id="afi-' + pItem.id
                + '">' + vTemp + '</ul>';
            break;
        default: null;
    }
    if (pItem.type == "critical" || pItem.type == "buttonList") return vTemp;
	if (pItem.type == "related") {
		return '<div class="col col-12 apex-col-auto"><div class="ajaxForm__related' + ((vValue == 'Y') ? ' green' : '') + '" id="afi-' + pItem.id + '-box">'
		       + '<div class="ajaxForm__item_box" id="afi-' + pItem.id + '">' + vTemp + '</div>'
			   + '</div></div></div>';   
	}
    return '<div class="col col-12 apex-col-auto ajaxForm__item" id="afi-' + pItem.id + '">' + (pItem.label ? '<label class="t-Form-label">' + pItem.label + '</label> ' : '') + vTemp + '</div>';
};

vms.item.relatedToggle = function (pThis){
    let $item = $(pThis).siblings("input");
    let lov = JSON.parse( decodeURIComponent($item.data("lov")) );
    let value = $item.val();
    for (let i = 0; i < lov.length; i++) {
        if (lov[i].val != value) {
            $item.val(lov[i].val).trigger('change');
            $item.siblings('.t-Form-label').text(lov[i].text);
        }
    }
}


vms.item.setVal = function (pId, pVal) {
    $s(pId, pVal);
    if (pId == 'cpc_critical') {
        let itemIndex = ajaxForm.genData.items.map(e => e.id);
        let itemLov = ajaxForm.genData.items[itemIndex.indexOf(pId)].lov;
        let itemLovIndex = itemLov.map(e => e.val).indexOf(pVal);
        let $item = $("#" + pId).parent();
        $item.removeClass("blue green red").addClass(itemLov[itemLovIndex].class);
    }
};

vms.item.getVal = function (pItem) {
    var vValue;
    switch (pItem.type) {
        case "C": var checkboxValues = [];
            $("#" + pItem.id + " > input:checked").map(function () { checkboxValues.push($(this).val()); });
            vValue = checkboxValues.join(':');
            break;
        default: vValue = $v(pItem.id);
    }
    return vValue;
}

vms.item.init = function () {
    let $items;
    // Datepickers
    $items = $(".ajaxForm input.ajaxForm__lxpMrDate");
    if ($items.length > 0) $items.datepicker({ dateFormat: translation.date_format });
    // Regular select box
    $items = $(".ajaxForm select.ajaxForm__mrSelect");
    if ($items.length > 0) $items.select2();
    // js Array driven selectbox
    $items = $(".ajaxForm input.ajaxForm__mrSelectArr")
    if ($items.length > 0) $items.each(function () {
        $(this).select2({ data: ajaxForm.genData.lov[ajaxForm.getLovIndex(this.getAttribute("lov"))].data });
    });
    // AJAX driven selectbox
    $items = $(".ajaxForm select.lxpMrSelectAjax");
    if ($items.length > 0) $items.select2({
        width: 'resolve',
        ajax: {
            url: "wwv_flow.show",
            dataType: "json",
            traditional: true,
            cache: false,
            data: function (params) {
                return {
                    p_flow_id: $v("pFlowId"),
                    p_flow_step_id: $v("pFlowStepId"),
                    p_instance: $v("pInstance"),
                    p_request: "APPLICATION_PROCESS=ajaxLov",
                    x01: $(this).attr("ajax"),
                    x02: params.term,
                    x03: $(this).closest("tr").find("[name=" + $(this).attr("cascade") + "]").val(),
                    x04: 1,
                    x05: i
                }
            }
        }
    });
}



var genItem = vms.item.gen;
var initItems = vms.item.init;
var getItemVal = vms.item.getVal;
var setItemVal = vms.item.setVal;

var refresh_item = vms.item.refresh_item;